import {useEffect, useState} from "react";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {createPaymentCheckout, getPaymentStatus} from "@corporatesclub/shared";
import {useI18n} from "./I18nProvider";
import {paths} from "@/lib/paths";

export function PaymentView() {
  const {t} = useI18n();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const orderId = params.get("orderId");
  const hash = params.get("hash");
  const status = params.get("status");
  const [error, setError] = useState("");
  const [redirecting, setRedirecting] = useState(false);
  const [payment, setPayment] = useState<Awaited<ReturnType<typeof getPaymentStatus>> | null>(null);
  useEffect(() => {
    if(orderId) {
      getPaymentStatus(parseInt(orderId, 10)).then(setPayment).catch((e: Error) => setError(e.message));
      return;
    }
    if(hash || !orderId) {
      setRedirecting(true);
      createPaymentCheckout({hash: hash || undefined}).then((r) => {
        window.location.href = r.checkoutUrl;
      }).catch((e: Error) => {
        setError(e.message);
        setRedirecting(false);
        setTimeout(() => navigate(paths.contact), 5000);
      });
    }
  }, [orderId, hash, navigate]);
  if(redirecting && !orderId) {
    return (
      <div className="loadingPay">
        {t("Please wait, we are redirecting you to the secure payment page...")}
        <img src="/images/payment_box.png" id="circleImage" alt="" />
      </div>
    );
  }
  if(error && !payment) {
    return (
      <div className="loadingPay">
        <br />{error}<br />
        {t("We will redirect you to the contact page in")} <b>5 {t("seconds")}</b>...
      </div>
    );
  }
  if(!payment) return <p>{t("Loading products...")}</p>;
  return (
    <>
      <h1 className="mainTitle wLine smallBot cmsPage"><span>{t("Order payment")}</span></h1>
      <div id="raspunsPlasareComanda" style={{display: "block"}}>
        {payment.paid ? (
          <>
            <h5>{t("Payment for the order")} <b>#{payment.orderId}</b> {t("it was done successfully!")}</h5>
            <p>{t("We will contact you as soon as possible to confirm the order.")}</p>
          </>
        ) : payment.paymentError || status === "cancel" ? (
          <>
            <h5>{t("Payment for the order")} <b>#{payment.orderId}</b> {t("it was not done successfully!")}</h5>
            <p>{t("Please contact us to fix this issue.")}</p>
            <p><Link to={paths.contact} className="anim">{t("Contact us")}</Link></p>
          </>
        ) : (
          <>
            <h5>{t("Payment is being processed!")}</h5>
            <p>{t("Thank you, payment for the order")} <b>#{payment.orderId}</b> {t("is in processing.")}</p>
            <p>{t("We will contact you as soon as possible to confirm the order.")}</p>
          </>
        )}
      </div>
    </>
  );
}
